export const MATERIAL_UNIT_SELECT_OPTIONS: { value: string; label: string }[] = [
  { value: "kg", label: "Kilogramos (kg)" },
  { value: "gr", label: "Gramos (gr)" },
  { value: "m", label: "Metros (m)" },
  { value: "cm", label: "Centímetros (cm)" },
  { value: "l", label: "Litros (l)" },
  { value: "ml", label: "Mililitros (ml)" },
  { value: "m2", label: "Metro cuadrado (m²)" },
  { value: "cm2", label: "Centímetro cuadrado (cm²)" },
  { value: "m3", label: "Metro cúbico (m³)" },
  { value: "cm3", label: "Centímetro cúbico (cm³)" },
  { value: "u", label: "Unidad (u)" },
]

function stripDiacritics(s: string): string {
  return s.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
}

function normUnitLabel(s: string): string {
  return stripDiacritics(
    s
      .toLowerCase()
      .replace(/\u00b2/g, "2")
      .replace(/\u00b3/g, "3")
      .replace(/²/g, "2")
      .replace(/³/g, "3")
  )
}

export function coerceRawUnitToMaterialSelectValue(raw: string): string {
  let t = raw.trim()
  if (!t) return ""
  t = t.replace(/\u00b2/g, "2").replace(/\u00b3/g, "3").replace(/²/g, "2").replace(/³/g, "3")
  const lower = t.toLowerCase()
  const compact = lower.replace(/\s+/g, "")
  if (compact === "ud" || compact === "uds") return "u"
  const byCompact = MATERIAL_UNIT_SELECT_OPTIONS.find((o) => o.value === compact)
  if (byCompact) return byCompact.value
  const byValue = MATERIAL_UNIT_SELECT_OPTIONS.find((o) => o.value.toLowerCase() === lower)
  if (byValue) return byValue.value
  const nRaw = normUnitLabel(t)
  const byLabel = MATERIAL_UNIT_SELECT_OPTIONS.find((o) => normUnitLabel(o.label) === nRaw)
  if (byLabel) return byLabel.value
  const paren = lower.match(/\(([^)]+)\)\s*$/)
  if (paren) {
    const inner = paren[1].replace(/\u00b2/g, "2").replace(/\u00b3/g, "3").toLowerCase()
    const byInner = MATERIAL_UNIT_SELECT_OPTIONS.find((o) => o.value.toLowerCase() === inner)
    if (byInner) return byInner.value
  }
  const z = nRaw
  if (/\b(c\/u|c\s*u|x\s*u|unidad|unidades)\b/i.test(z) || z === "u" || z === "u." || z === "c/u") {
    return "u"
  }
  if (/(kilogram|kilos|kilo)\b/.test(z) || /\bkg\b/.test(z)) return "kg"
  if (/(mililitro|mililitros)\b/.test(z) || /\bml\b/.test(z)) return "ml"
  if (/(litro|litros)\b/.test(z) && !/mili/.test(z)) return "l"
  if (/(gramo|gramos)\b/.test(z) && !/kilo/.test(z)) return "gr"
  if (/(metro|metros)\s*c[uu]bic/.test(z) || /metros?\s*c[uu]bicos?/.test(z)) return "m3"
  if (/(metro|metros)\s*cua?dr/.test(z) || /metros?\s*cua?drados?/.test(z)) return "m2"
  if (/(cent[ií]metro|cent[ií]metros)\s*c[uu]bic/.test(z)) return "cm3"
  if (/(cent[ií]metro|cent[ií]metros)\s*cua?dr/.test(z)) return "cm2"
  if (/(cent[ií]metro|cent[ií]metros)\b/.test(z)) return "cm"
  if (/\b(m|metros?)\b/.test(z) && !/centi/.test(z) && !/mili/.test(z) && !/cua?dr/.test(z) && !/c[uu]bic/.test(z)) {
    return "m"
  }
  const tokens = z.split(/[^a-z0-9/]+/).filter(Boolean)
  for (const tok of tokens) {
    const t2 = tok.replace(/²/g, "2").replace(/³/g, "3")
    const hit = MATERIAL_UNIT_SELECT_OPTIONS.find((o) => o.value === t2 || o.value === tok)
    if (hit) return hit.value
  }
  return ""
}
